import { IRecommendedServicePackages } from '../../../../../redux/reducers';
import { IRecommendedServicePackageSchema } from '../../internalTypes';
import { getServiceId } from '../getServiceId';

export function mapRecommendedPackages(
  recommendedPackages: IRecommendedServicePackageSchema[],
): IRecommendedServicePackages {
  return recommendedPackages.reduce((acc, recommendedPackage) => {
    acc[recommendedPackage.id] = {
      ...recommendedPackage,
      serviceId: getServiceId(recommendedPackage),
      discount: parseFloat(recommendedPackage.discount),
      marketingPricePerDay: parseFloat(recommendedPackage.marketingPricePerDay),
      totalPrice: parseFloat(recommendedPackage.totalPrice),
      totalMarketingPrice: parseFloat(recommendedPackage.totalMarketingPrice),
      pricePerDay: parseFloat(recommendedPackage.pricePerDay),
    };

    return acc;
  }, {} as IRecommendedServicePackages);
}
